import PropTypes from 'prop-types';
import { Stack, Button, Text, Group, Box } from '@mantine/core';
import { colors, fontSize } from '../constants';
import { useAppContext, SET_WINDOWS } from '../context/AppContext';
import singleWindow from '../images/ui_buttons/window-button-single.png';
import doubleWindow from '../images/ui_buttons/window-button-double.png';

const WindowChoiceMobile = ({ selectedWindow, onWindowClick }) => {
	const { dispatch } = useAppContext();

	const handleWindowChoice = (windowId) => {
		console.log('WindowChoiceMobile received click on', windowId);
		dispatch({ type: SET_WINDOWS, payload: windowId });
		onWindowClick(windowId);
	};

	return (
		<Box style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
			<Stack gap="15px" align="center" style={{ width: '100%' }}>
				<Text style={{
					color: colors.white,
					fontSize: fontSize.xl,
					fontWeight: 'bold',
					textAlign: 'center',
					marginTop: '15px',
					marginBottom: '0px'
				}}>
					Windows
				</Text>
				
				<Group justify="center" gap="5px" style={{ width: '100%' }}>
					<Button
						variant="filled"
						onClick={() => handleWindowChoice('windows_one')}
						styles={{
							root: {
								backgroundColor: selectedWindow === 'windows_one' ? colors.buttonGreen : colors.buttonColor,
								borderRadius: '12px',
								height: 80,
								width: 80,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								padding: 0
							}
						}}
					>
						<img src={singleWindow} alt='One Window' style={{ width: 25, height: 40 }} />
					</Button>
					
					<Button
						variant="filled"
						onClick={() => handleWindowChoice('windows_two')}
						styles={{
							root: {
								backgroundColor: selectedWindow === 'windows_two' ? colors.buttonGreen : colors.buttonColor,
								borderRadius: '12px',
								height: 80,
								width: 80,
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								padding: 0
							}
						}}
					>
						<img src={doubleWindow} alt='Two Windows' style={{ width: 40, height: 38}} />
					</Button>

          <Button
            variant="filled"
            onClick={() => handleWindowChoice('windows_none')}
            styles={{
              root: {
                backgroundColor: selectedWindow === 'windows_none' ? colors.buttonGreen : colors.buttonColor,
                borderRadius: '12px',
                height: 80,
                width: 80,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: 0
              }
            }}
          >
            <Text style={{
              color: colors.white,
              fontSize: fontSize.lg,
              fontWeight: 'bold'
            }}>
              None
            </Text>
          </Button>
				</Group>
				
				
			</Stack>
		</Box>
	);
};

WindowChoiceMobile.propTypes = {
	selectedWindow: PropTypes.string,
	onWindowClick: PropTypes.func.isRequired
};

export default WindowChoiceMobile;
